import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

const ENSERES_QUE_RECOGEMOS = [
  "Tendrán la consideración de muebles y enseres al objeto de este servicio, los utensilios, muebles y aparatos utilizados en el hogar como sofás, sillas, mesas, armarios, estanterías, camas, colchones y demás elementos análogos a los señalados de su uso doméstico.",
  "Este servicio es exclusivo para residuos generados en los domicilios (hogares) y para pequeñas cantidades.",
  "Quedan excluidos de este servicio las maniobras y acumulaciones de enseres propias de mudanzas, desalojos y obras de reforma. Asimismo, están excluidos los escombros y restos derivados de obras de reformas realizadas en los domicilios (mobiliario de cocinas, sanitarios, grifería, rejas… y demás residuos propios de una obra cuya responsabilidad de gestión como residuo recae en el solicitante del título habilitante de la reforma), ni los residuos peligrosos, como pinturas, disolventes, aceites, baterías, etc.",
  "Los residuos eléctricos y electrónicos y los residuos peligrosos deben llevarse al Punto Limpio Móvil. Los cristales y espejos, así como los muebles que los contengan, deben llevarse obligatoriamente al Punto Limpio Móvil.",
  "Por razones de operatividad, por cada servicio se podrá solicitar como máximo la recogida de TRES enseres ó bien UN ÚNICO mueble de grandes dimensiones (sofás, estanterías…).",
];

// Para empresas/pequeño comercio: sin la exclusión de "pequeñas cantidades" (punto 2, no aplica
// a su contexto) y sin la opción de mueble de grandes dimensiones (excluida para empresas).
const ENSERES_QUE_RECOGEMOS_EMPRESA = [
  ENSERES_QUE_RECOGEMOS[0],
  ENSERES_QUE_RECOGEMOS[2],
  ENSERES_QUE_RECOGEMOS[3],
  "Por razones de operatividad, por cada servicio se podrá solicitar como máximo la recogida de TRES enseres de pequeño tamaño.",
];

const ENSERES_COMO_SE_REALIZA = [
  "En el momento de realizar la solicitud, se deberá escoger como lugar en el que se realizará el depósito, la isla de contenedores soterrados más cercana a su domicilio.",
  "El depósito de los enseres será realizado la noche anterior (a partir de las 7 de la tarde) a la recogida de los mismos, que será practicada por el Servicio de Recogida a lo largo del día siguiente (LUNES, MIÉRCOLES O VIERNES).",
  <>También puede realizar la solicitud a través del teléfono: <strong className="text-municipal">916 75 18 10</strong>.</>,
];

const REQUISITOS_EMPRESAS = [
  "Ser sujeto pasivo de la tasa de basuras.",
  "Ser titular de una actividad empresarial y/o comercial desarrollada en la zona residencial en el término municipal de San Fernando de Henares, con local en el que haya libre concurrencia de público.",
  "Que se trate de Pymes, es decir de empresas que ocupan a menos de 250 personas y cuyo volumen de negocios anual no excede de 50 millones de euros o su balance general anual no excede de 43 millones de euros.",
  "Se excluyen de esta prestación los muebles y enseres de gran peso y volumen procedentes de establecimientos comerciales.",
];

const PODA_NORMAS = [
  "Las ramas deben depositarse formando atillos, con longitudes no superiores a un metro y un peso máximo de 25 kilogramos por atillo.",
  "Las hojas, restos de césped y recortes de seto deben depositarse en bolsas.",
  "Tanto los atillos como las bolsas cerradas deben depositarse junto a los contenedores de residuos sólidos urbanos, nunca en su interior.",
  "No se puede dejar una cantidad de restos de poda tal que bloquee el paso en la isla de soterrados o en la acera.",
  <><strong className="font-bold text-municipal">Se limita la cantidad a 3 bolsas o 3 atillos por servicio.</strong></>,
];

const TITULOS = {
  enseres: "Aviso de recogida de muebles y enseres viejos",
  poda: "Condiciones a seguir para la recogida de restos de poda",
};

function Lista({ items, testId }) {
  return (
    <ul className="space-y-2.5 text-sm text-gray-600" data-testid={testId}>
      {items.map((n, i) => (
        <li key={i} className="flex items-start gap-2">
          <span className="w-1.5 h-1.5 rounded-full bg-municipal mt-2 shrink-0" />
          {n}
        </li>
      ))}
    </ul>
  );
}

export default function NormasModal({ open, onClose, servicio, tipoSolicitante }) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto" data-testid="normas-modal">
        <DialogHeader>
          <DialogTitle className="text-municipal font-heading flex items-center gap-2">
            <AlertTriangle className="w-5 h-5 text-dorado" /> {TITULOS[servicio]}
          </DialogTitle>
        </DialogHeader>
        {servicio === "enseres" ? (
          <div className="space-y-5">
            {tipoSolicitante === "empresa" && (
              <div className="bg-municipal/5 border border-municipal/20 rounded-xl p-4">
                <h3 className="font-heading font-bold text-sm text-municipal mb-2">Requisitos para empresas y pequeño comercio</h3>
                <p className="text-sm font-bold text-gray-700 mb-2">
                  Las empresas y/o pequeño comercio local que soliciten beneficiarse de esta ayuda deberán
                  cumplir la totalidad de los siguientes requisitos:
                </p>
                <ul className="space-y-2.5 text-sm font-bold text-gray-700" data-testid="normas-lista-requisitos-empresas">
                  {REQUISITOS_EMPRESAS.map((n, i) => (
                    <li key={i} className="flex items-start gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-municipal mt-2 shrink-0" />
                      {n}
                    </li>
                  ))}
                </ul>
              </div>
            )}
            <div>
              <h3 className="font-heading font-semibold text-sm text-municipal mb-2">¿Qué recogemos?</h3>
              <Lista
                items={tipoSolicitante === "empresa" ? ENSERES_QUE_RECOGEMOS_EMPRESA : ENSERES_QUE_RECOGEMOS}
                testId="normas-lista-que-recogemos"
              />
            </div>
            <div>
              <h3 className="font-heading font-semibold text-sm text-municipal mb-2">¿Cómo se realiza el servicio?</h3>
              <Lista items={ENSERES_COMO_SE_REALIZA} testId="normas-lista-como-se-realiza" />
            </div>
            <p className="text-xs text-gray-500 bg-amber-50 border border-amber-200 rounded-lg p-3">
              Al realizar la solicitud, acepta los términos y condiciones que regulan este servicio. El
              incumplimiento de ello, así como el abandono de muebles y enseres en vía pública, podrá ser
              objeto de sanción desde 500 a 3.000 €, dependiendo del tipo de infracción.
            </p>
          </div>
        ) : (
          <div className="space-y-3">
            <p className="text-sm text-gray-600">
              Los restos de poda de árboles y arbustos y del mantenimiento de las plantas de jardines
              particulares y no realizado por empresa, deben seguir las siguientes indicaciones para su
              posterior recogida por la contrata de limpieza viaria y recogida de residuos:
            </p>
            <ol className="space-y-2.5 text-sm text-gray-600 list-decimal list-inside" data-testid="normas-lista">
              {PODA_NORMAS.map((n, i) => (
                <li key={i}>{n}</li>
              ))}
            </ol>
          </div>
        )}
        <Button onClick={onClose} className="w-full bg-municipal hover:bg-municipal-dark text-white mt-2" data-testid="normas-cerrar-btn">
          Entendido
        </Button>
      </DialogContent>
    </Dialog>
  );
}
